import styled from 'styled-components';
import { IThemeProvider } from '../../../../../../styles/theme';

interface ColorBlockProps extends IThemeProvider {
  color: string;
  shape: 'square' | 'circle';
  flattened: boolean;
}

export const ColorBlocks = styled.div<{ direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  align-items: flex-start;
  justify-content: end;
  gap: 10px;
  > * {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const ColorBlock = styled.div<ColorBlockProps>`
  width: ${({ shape }) => (shape === 'square' ? '40px' : '18px')};
  height: ${({ flattened }) => (flattened ? '8px' : '18px')};
  border-radius: ${({ shape }) => (shape === 'square' ? '4px' : '100%')};
  ${({ color }) => `
      background: ${color};
    `}
`;
